module.exports = __webpack_public_path__ + "img/user-detail-icon.e1ba7e7b.svg";